import { useState } from "react";
import { Clock } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

const SLOTS = Array.from({ length: 48 }, (_, i) => {
  const h = String(Math.floor(i / 2)).padStart(2, "0");
  const m = i % 2 ? "30" : "00";
  return `${h}:${m}`;
});
const label = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const ap = h < 12 ? "AM" : "PM";
  const hh = h % 12 || 12;
  return `${hh}:${String(m).padStart(2, "0")} ${ap}`;
};

// Branded time picker. value/onChange use 24h "HH:MM" strings.
export function TimePicker({ value, onChange, testid, className, placeholder = "Time" }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={cn("inline-flex items-center gap-1.5 rounded-md border border-slate-200 bg-white px-2 text-sm text-slate-700 hover:border-fuchsia-400", !value && "text-slate-400", className)}>
          <Clock className="h-3.5 w-3.5 shrink-0 text-slate-400" />
          <span>{value ? label(value) : placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="max-h-64 w-32 overflow-y-auto p-1" align="start">
        {SLOTS.map((t) => (
          <button key={t} type="button" data-testid={testid ? `${testid}-opt-${t}` : undefined}
            onClick={() => { onChange(t); setOpen(false); }}
            className={cn("block w-full rounded px-2 py-1 text-left text-xs hover:bg-slate-100", value === t && "bg-fuchsia-50 font-semibold text-fuchsia-700")}>{label(t)}</button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
